import * as React from 'react';
import { IPageName } from '../types/apiSchema';

export const defaultPage: IPageName = IPageName.currentSales;

export const PageContext: React.Context<IPageName> = React.createContext<IPageName>(defaultPage);

PageContext.displayName = 'PageContext';
